export enum FetchPolicy {
  CACHE_FIRST = 'cache-first',
  NETWORK_ONLY = 'network-only',
  CACHE_ONLY = 'cache-only',
  NO_CACHE = 'no-cache',
  STANDBY = 'standby'
}

export enum ErrorPolicy {
  NONE = 'none',
  IGNORE = 'ignore',
  ALL = 'all'
}
